export const progressspinner = {
  colorScheme: {
    light: {
      root: {
        colorOne: "{highlight.default}",
        colorTwo: "{highlight.default}",
        colorThree: "{highlight.default}",
        colorFour: "{highlight.default}",
      },
    },
    dark: {
      root: {
        colorOne: "{highlight.default}",
        colorTwo: "{highlight.default}",
        colorThree: "{highlight.default}",
        colorFour: "{highlight.default}",
      },
    },
  },
};
